import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT, MAX_PAGE_WIDTH } from '../../../styles/constants';

const dialogHeaderHeight = '73px';
const safeArea = {
  top: 'env(safe-area-inset-top, 0px)',
  right: 'env(safe-area-inset-right, 0px)',
  bottom: 'env(safe-area-inset-bottom, 0px)',
  left: 'env(safe-area-inset-left, 0px)',
} as const;
const layoutBottomGap = 'var(--vv-layout-bottom-gap, 0px)';
const bottomInset = `calc(${safeArea.bottom} + var(--vv-layout-bottom-gap, 0px))`;

export const useStyles = makeStyles<Theme>()((theme) => ({
  appDialogWrapper: {
    width: '500px',
    maxWidth: MAX_PAGE_WIDTH,
    height: 'auto',
    maxHeight: MAX_PAGE_HEIGHT,
    borderRadius: '10px',

    [theme.breakpoints.down('md')]: {
      width: '100dvw',
      maxWidth: '100dvw',
      height: MAX_PAGE_HEIGHT,
      maxHeight: MAX_PAGE_HEIGHT,
      marginTop: safeArea.top,
      marginBottom: bottomInset,
      marginLeft: safeArea.left,
      marginRight: safeArea.right,
    },
  },
  appDialogHeader: {
    padding: '24px',
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',

    '& svg': {
      cursor: 'pointer',
    },
  },
  appDialogHeaderTitle: {
    ...theme.mixins.appEllipsis,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.text.primary,
  },
  appDialogContent: {
    padding: theme.spacing(3),
    width: '100%',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.5),
    },
  },
  appDialogContentWrapper: {
    [theme.breakpoints.down('md')]: {
      height: `calc(100% - ${dialogHeaderHeight})`,
      maxHeight: `calc(100% - ${dialogHeaderHeight})`,
      overflowY: 'auto',
    },
  },
}));
